import { styled } from "@mui/material/styles";
import Checkbox from "@bmi-digital/components/checkbox";
import { formControlClasses } from "@mui/material/FormControl";
import { formControlLabelClasses } from "@mui/material/FormControlLabel";
import { formHelperTextClasses } from "@mui/material/FormHelperText";
import { filledInputClasses } from "@mui/material/FilledInput";
import ProgressIndicator from "../../ProgressIndicator";

const PREFIX = "EmbeddedRegistrationForm";
export const classes = {
  gridFullWidth: `${PREFIX}-grid-full-width`,
  termsAndConditionsCheckbox: `${PREFIX}-terms-and-conditions-checkbox`
};

export const StyledFormElementsContainer = styled("div")(({ theme }) => ({
  [`& .${formControlClasses.root}>.${formHelperTextClasses.error}.${formHelperTextClasses.root}`]:
    {
      display: "none"
    },

  [`& .${filledInputClasses.root}.${filledInputClasses.focused}`]: {
    backgroundColor: theme.colours.white
  },

  [`&& .${classes.termsAndConditionsCheckbox} .${formControlLabelClasses.root}`]:
    {
      color: "inherit"
    }
}));

export const StyledAlertBannerWrapper = styled("div")({
  marginTop: "24px",
  textAlign: "center"
});

export const StyledProgressIndicator = styled(ProgressIndicator)({
  position: "relative",
  left: 0,
  right: 0,
  marginLeft: "0.5rem"
});

export const StyledGridContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gap: "16px",
  gridTemplateRows: "repeat(4, auto)",

  [theme.breakpoints.up(1025)]: {
    gridTemplateColumns: "1fr 1fr",

    [`&>.${classes.gridFullWidth}`]: {
      gridColumn: "1 / -1"
    }
  }
}));

export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  [theme.breakpoints.up(1025)]: {
    marginTop: "7px"
  },
  "& .MuiFormControlLabel-root": {
    alignItems: "center",
    marginRight: 0,
    marginBottom: 6
  },
  "& .MuiFormControlLabel-label": {
    display: "inline",
    marginLeft: 0
  },
  "& .MuiStack-root": {
    display: "inline"
  },
  "& .MuiTypography-root": {
    display: "inline"
  },
  "& .MuiFormControlLabel-asterisk": {
    display: "inline",
    marginLeft: "4px"
  }
}));
